/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { CalendarUserType } from '../enums/calendar-user-type';
import { CalendarEventEntity } from './calendar-event-entity';
export class CalendarEntity extends Entity {
  candidateId: string | null = null;
  contactId: string | null = null;
  events: CalendarEventEntity[] = [];
  freeTimeUpdatedAt: string | null = null;
  freeTimeUpdatedUserType: CalendarUserType | null = null;
  id: string = '';
  timezone: string | null = null;
  static override key = 'Calendar';
  static override get schema() {
    return {
      events: [CalendarEventEntity],
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'Calendar' in input
    ) {
      const { Calendar: wrapped, ...rest } = input as {
        Calendar: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}